import React from 'react';

import { PaysendLogo } from 'apps/auth/components/common/PaysendLogo/PaysendLogo';
import { Text } from 'apps/auth/components/common/Text/Text';

import { CardSmallContainer } from './styles';

interface CardSmallProps {
    isPurple?: boolean;
    isLinked?: boolean;
    cardText?: string;
}

export const CardSmall: React.FC<CardSmallProps> = ({ isPurple, isLinked, cardText }) => {
    return (
        <CardSmallContainer $isPurple={isPurple} $isLinked={isLinked}>
            <PaysendLogo color={isPurple ? 'white' : 'darkGray'} />
            <Text color={isPurple ? 'whiteRgba40' : 'secondary'}>{cardText}</Text>
        </CardSmallContainer>
    );
};
